import React from 'react';
import { withRouter } from 'react-router-dom';
import '../../assets/admin/css/login.css';
import '../../assets/admin/css/admin.scss';
class Sidebar extends React.Component {
  constructor() {
    super();
    this.state = {login:""};
  }
  render() {
    return (
         <>
     <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">         
          <li class="nav-item">
          <a class={this.props.location.pathname === '/GetInvolvedList' ? 'nav-link active' : 'nav-link'} href="/GetInvolvedList">            
              <span class="menu-title">Get Involved List</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/DonationList' ? 'nav-link active' : 'nav-link'} href="/DonationList">            
              <span class="menu-title">Donation List</span>
            </a>
          </li>         
         
          <li class="nav-item">
          <a class={this.props.location.pathname === '/ActivitieList' ? 'nav-link active' : 'nav-link'} href="/ActivitieList">            
              <span class="menu-title">Activities List</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/AddActivitie' ? 'nav-link active' : 'nav-link'} href="/AddActivitie">            
              <span class="menu-title">Add Activitie </span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/CoSponsor' ? 'nav-link active' : 'nav-link'} href="/CoSponsor">            
              <span class="menu-title">Add Sponsor</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/addgallery' ? 'nav-link active' : 'nav-link'} href="/addgallery">            
              <span class="menu-title">Add Gallery</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/addUnderprivilege' ? 'nav-link active' : 'nav-link'} href="/addUnderprivilege">            
              <span class="menu-title"> Add privilege Gallery</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/addAnnualReport' ? 'nav-link active' : 'nav-link'} href="/addAnnualReport">            
              <span class="menu-title">Add Annual Report</span>
            </a>
          </li>
          <li class="nav-item">
          <a class={this.props.location.pathname === '/addmeta' ? 'nav-link active' : 'nav-link'} href="/addmeta">            
              <span class="menu-title">Add Metatags</span>
            </a>
          </li>
          <li class="nav-item">
                       
              <span class="menu-title nav-link" onClick={() => {
    sessionStorage.removeItem('isLoggedIn');
    window.location.href = '/';
  }}
>Logout</span>
            
          </li>
          
        </ul>
      </nav>
         </>
    );
  }
}
export default withRouter(Sidebar);